export default __webpack_public_path__ + "alberta-minus.80fddabe5314969b69aa.svg";